<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="vx-row">
    <!-- USER PRODFILE CARD -->
    <div class="vx-col w-full lg:w-full mb-base" v-if="(windowWidth >= 480)">
      <vx-card title="รายการเดินบัญชี">
        <vs-table :data="transactions">

          <template slot="thead">
            <vs-th>วันที่ทำรายการ</vs-th>
            <vs-th>ประเภทรายการ</vs-th>
            <vs-th class="bold">ยอดเงิน</vs-th>
            <vs-th class="text-right">ยอดเงินกู้คงเหลือ (เงินต้น)</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="index" v-for="(transaction, index) in data">

              <vs-td>
                <span class="bold">{{ transactionDate(transaction) }}</span><br>
                <span>{{ transactionTime(transaction) }}</span>
              </vs-td>

              <vs-td>
                <span class="bold">{{ transactionType(transaction) }}</span>
              </vs-td>

              <vs-td>
                <span class="bold cursor-pointer" v-if="transaction.transactionType === 'AddPayment'"><a>{{ amount(transaction) | numberFormat }}</a></span>
                <!-- @click="btnTransactionPayment(transaction.id)" -->
                <span class="bold" v-if="transaction.transactionType !== 'AddPayment'">{{ amount(transaction) | numberFormat }}</span><br>
                <span>บาท</span>
              </vs-td>

              <vs-td>
                <span class="bold">{{ transaction.principleRemain | numberFormat }}</span><br>
                <span>บาท</span>
              </vs-td>

            </vs-tr>
          </template>

        </vs-table>
      </vx-card>
    </div>
    <div class="vx-col w-full lg:w-full mb-base list-card" v-if="(windowWidth < 480)">
        <vx-card :key="index" v-for="(transaction, index) in transactions" class="mb-3">
          <span class="title-head">{{ transactionType(transaction) }}</span><hr>
          <div class="vx-row mt-2">
            <div class="vx-col w-full flex">
              <span class="label text-left">วันที่ทำรายการ</span>
              <vs-spacer />
              <span class="text-right">
                <span class="bold">{{ transactionDate(transaction) }} {{ transactionTime(transaction) }}</span>
              </span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full flex">
              <span class="label text-left">ยอดเงิน (บาท)</span>
              <vs-spacer />
              <span class="text-right">
                <span class="bold cursor-pointer" v-if="transaction.transactionType === 'AddPayment'"><a>{{ amount(transaction) | numberFormat }}</a></span>
                <!-- @click="btnTransactionPayment(transaction.id)" -->
                <span class="bold" v-if="transaction.transactionType !== 'AddPayment'">{{ amount(transaction) | numberFormat }}</span><br>
              </span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full flex">
              <span class="label text-left">ยอดเงินกู้คงเหลือ (บาท)</span>
              <vs-spacer />
              <span class="bold text-right">{{ transaction.principleRemain | numberFormat }}</span>
            </div>
          </div>
        </vx-card>
    </div>
    <vs-popup title="รายละเอียดการชำระ" :active.sync="transactionPaymentPopup.active">
      <div>
        <div class="vx-row flex">
          <span class="vx-col flex-1 text-left label">ค่าธรรมเนียม</span>
          <span class="vx-col flex-1 text-right label-bold">{{ transactionPaymentPopup.paidFee | numberFormat }}</span>
        </div>
        <div class="vx-row flex">
          <span class="vx-col flex-1 text-left label">เบี้ยปรับ</span>
          <span class="vx-col flex-1 text-right label-bold">{{ transactionPaymentPopup.paidPenalty | numberFormat }}</span>
        </div>
        <div class="vx-row flex">
          <span class="vx-col flex-1 text-left label">ดอกเบี้ย</span>
          <span class="vx-col flex-1 text-right label-bold">{{ transactionPaymentPopup.paidInterest | numberFormat }}</span>
        </div>
        <div class="vx-row flex">
          <span class="vx-col flex-1 text-left label">เงินต้น</span>
          <span class="vx-col flex-1 text-right label-bold">{{ transactionPaymentPopup.paidPrinciple | numberFormat }}</span>
        </div><br>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const moment = require('moment');
import { paidTransactionDetail, isEmpty } from '@/utils'
const { mapActions: mapAccountingActions, mapState: mapAccountingState } = createNamespacedHelpers('Accounting')
export default {
  data () {
    return {
      transactionPaymentPopup: {
        active: false,
        paidFee: 0,
        paidPenalty: 0,
        paidInterest: 0,
        paidPrinciple: 0,
      }
    }
  },
  async created() {
    const vm = this
    if(isEmpty(vm.contract)){
      vm.$router.push("/")
    }else{
      await vm.getTransactionsActionByContractId({
        form: {
          contractId: vm.contract.id,
          filters: {
            limit: 0,
            action: 'All',
            year: 0
          }
        }
      });
    }

  },
  computed: {
    ...mapAccountingState(['status', 'contract', 'loan', 'transactions']),
    windowWidth () {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    ...mapAccountingActions([
      'getContractsByCurrentUser',
      'getContract',
      'getTransactionsActionByContractId',
      'getLastPaymentByContractId'
    ]),
    transactionDate(res) {
      const vm = this
      return vm.$options.filters.toThaiDDMMMYYYYFormat(moment.utc(res.transactionDateTime).format("YYYY-MM-DD"))
    },
    transactionTime(res) {
      return moment.utc(res.transactionDateTime).format("HH:mm น.")
    },
    transactionType(res) {
      const vm = this
      let transactionType = ""
      if(res.transactionType === 'AddRestructuring'){
        transactionType = vm.$t('general.transactionTypes.AddRestructuring')
      }else if(res.transactionType === 'AddLoanDetail'){
        transactionType = vm.$t('general.transactionTypes.AddLoanDetail')[res.loanDetail.loanDetailType]
      }else if(res.transactionType === 'AddFeeDetail'){
        transactionType = vm.$t('general.transactionTypes.AddFeeDetail')[res.feeDetail.feeType]
      }else if(res.transactionType === 'AddPayment'){
        transactionType = vm.$t('general.transactionTypes.AddPayment')
      }
      return transactionType
    },
    amount(res) {
      let amount = 0
      if(res.transactionType === 'AddRestructuring'){
        amount = res.restructuringDetail.principleRemain
      }else if(res.transactionType === 'AddLoanDetail'){
        amount = res.loanDetail.amount
      }else if(res.transactionType === 'AddFeeDetail'){
        amount = res.feeDetail.amount
      }else if(res.transactionType === 'AddPayment'){
        amount = res.payment.paymentAmount
      }
      return amount
    },
    btnTransactionPayment (id) {
      const vm = this
      const transaction = vm.transactions.find(transaction => transaction.id === id)
      const res = paidTransactionDetail(transaction)
      vm.transactionPaymentPopup = {
        active: true,
        paidFee: res.paidFee,
        paidPenalty: res.paidPenalty,
        paidInterest: res.paidInterest,
        paidPrinciple: res.paidPrinciple,
      }
    }
  },
  watch: {
    'status.processing'(val) {
      if(val){
        this.$vs.loading();
      }else{
        this.$vs.loading.close();
      }
    }
  }
};
</script>


<style>

  span.label{
    color: #8389a2
  }
  span.bold{
    color: #000000;
    font-size: 15px;
    font-weight: 600;
  }
  table th {
    color: #000000;
    font-size: 15px;
    font-weight: 600;
  }

  .con-vs-popup .vs-popup {
    width: 400px !important;
    height: auto !important;
  }

  .list-card{
    line-height: 2.5;
  }
  .list-card span.title-head {
    color: #0f4c81;
    font-size: 20px;
    font-weight: 600;
  }
  .list-card span.title-bold{
    color: #000000;
    font-size: 18px;
    font-weight: 600;
  }
  .list-card span.label{
    color: #8389a2;
    font-size: 14px;
    font-weight: 400;
  }
  .list-card span.label-bold{
    color: #000000;
    font-size: 14px;
    font-weight: 600;
  }
  .list-card hr{
      border: 0.1px solid #8389a2;
  }
</style>
